export default __webpack_public_path__ + "static/media/no_img_network.ad38f68e.png";